"use client"

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { CustomEase } from "gsap/all"
import ForwardArrow from "images/Icons/ForwardArrowL.inline.svg"
import { InfiniteSideScroll } from "library/InfiniteSideScroll"
import UniversalLink from "library/link"

import {
	css,
	fmobile,
	fresponsive,
	ftablet,
	styled,
	unresponsive,
} from "library/styled"
import { useRef } from "react"
import colors from "styles/colors"
import textStyles from "styles/text"
import links from "utils/links"

gsap.registerPlugin(ScrollTrigger, CustomEase)

export default function MarqueeSection() {
	const sideScroll = useRef<HTMLDivElement | null>(null)

	return (
		<Wrapper>
			<Inner href={links.contact}>
				<LeftBlur />
				<ScrollWrapper ref={sideScroll}>
					<InfiniteSideScroll disableDrag marqueeSpeed={0.2}>
						<Content>
							<MarqueeIcon>
								<ForwardArrow />
							</MarqueeIcon>
							<MarqueeText>Get a Custom Quote Today</MarqueeText>
							<SmallText>
								offering quality healthcare without compromising
							</SmallText>
						</Content>
					</InfiniteSideScroll>
				</ScrollWrapper>
				<RightBlur />
			</Inner>
		</Wrapper>
	)
}

const Wrapper = styled("div", {
	...unresponsive(css`
		background-color: ${colors.offWhite};
	`),
	...fresponsive(css`
		position: relative;
		width: 100%;
		display: grid;
		place-items: center;
		padding: 0 0 80px;
	`),

	...ftablet(css`
		padding-top: 80px;
		border-top: 0.75px solid ${colors.green100};
	`),
	...fmobile(css`
		padding: 24px 0;
	`),
})

const MarqueeText = styled("div", {
	...fresponsive(css`
		${textStyles.h5}
		color: ${colors.green400};
	`),
})

const MarqueeIcon = styled("div", {
	...fresponsive(css`
		position: relative;
		display: inline-block;
		width: 50px;
		height: 50px;
		margin: 0 30px;
		color: ${colors.green400};

		svg {
			width: 100%;
			height: 100%;

			rect {
				fill: transparent;
			}
		}
	`),
})

const ScrollWrapper = styled("div", {
	...fresponsive(css`
		position: relative;
		width: 1440px;
		height: 190px;
		display: grid;
		overflow: clip;
		place-items: center;

		.track {
			padding: 20px 0;
			margin: -20px 0;
			display: flex;
			align-items: center;
		}
	`),

	...ftablet(css`
		width: 100%;
	`),

	...fmobile(css`
		width: 100%;
	`),
})

const SmallText = styled("div", {
	...fresponsive(css`
		${textStyles.titleR};
		color: ${colors.green400};
		width: 300px;
	`),
})

const Content = styled("div", {
	...fresponsive(css`
		display: flex;
		align-items: center;
		gap: 32px;
	`),

	...fmobile(css`
		flex-direction: row;
	`),
})

const LeftBlur = styled("div", {
	...fresponsive(css`
		position: absolute;
		top: 0;
		left: 0;
		width: 108px;
		height: 100%;
		background: linear-gradient(
			270deg,
			rgba(251 250 246 / 0%) 0%,
			#fbfaf6 100%
		);
		z-index: 3;
	`),
})

const RightBlur = styled(LeftBlur, {
	...fresponsive(css`
		position: absolute;
		left: unset;
		right: 0;
		transform: rotate(180deg);
	`),
})

const Inner = styled(UniversalLink, {
	...fresponsive(css`
		position: relative;
		cursor: pointer !important;
		width: 1440px;
	`),

	...ftablet(css`
		width: 100%;
	`),

	...fmobile(css`
		width: 100%;
	`),
})
